import { useCallback, useState } from 'react'

const STORAGE_KEY = 'builder.rail.pinned'

// Pinning survives a reload: the rail is the only nav surface, so a user who
// wants labels wants them every session, not until the next refresh.
export function useRailPinned(): [boolean, () => void] {
  const [pinned, setPinned] = useState(() => {
    try {
      return window.localStorage.getItem(STORAGE_KEY) === 'true'
    } catch {
      return false
    }
  })

  const toggle = useCallback(() => {
    setPinned(prev => {
      const next = !prev
      try {
        window.localStorage.setItem(STORAGE_KEY, String(next))
      } catch {
        // Private browsing or blocked storage — the pin just won't persist.
      }
      return next
    })
  }, [])

  return [pinned, toggle]
}
